<template>
  <v-container fluid>
    <material-card icon="mdi-google-classroom" title="Register Staff">
      <div v-if="trainingByTrainers">
        <v-row>
          <v-col cols="3">Training Type :</v-col>
          <v-col cols="3">{{ trainingByTrainers.type }}</v-col>
        </v-row>

        <v-row
          v-if="
            trainingByTrainers.selfInvitation === true &&
            trainingByTrainers.type != 'offline'
          "
        >
          <v-col cols="3">Self Invitation :</v-col>
          <v-col cols="3">Self Invited</v-col>
        </v-row>
        <v-row>
          <v-col cols="3">Training Title :</v-col>
          <v-col cols="3">{{ trainingByTrainers.title }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="3">Dates :</v-col>
          <v-col cols="3"
            >From : {{ formatDate(trainingByTrainers.fromDate) }}</v-col
          >
          <v-col cols="3"
            >To : {{ formatDate(trainingByTrainers.toDate) }}</v-col
          >
        </v-row>
        <v-row>
          <v-col cols="3">Time :</v-col>
          <v-col cols="3">From : {{ trainingByTrainers.fromTime }}</v-col>
          <v-col cols="3">To : {{ trainingByTrainers.toTime }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="3">Trainer :</v-col>
          <v-col cols="3">
            <span
              v-for="(trainer, index) in trainingByTrainers.trainingTrainerMaps"
              :key="index"
            >
              {{ trainer.user.firstName + ' ' + trainer.user.lastName }}
              <span
                v-if="index + 1 < trainingByTrainers.trainingTrainerMaps.length"
                >and</span
              >
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">Training Location :</v-col>
          <v-col cols="3">{{ trainingByTrainers.locationCenterAddress }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="3">Classes :</v-col>
          <v-col cols="3">{{ className.join(', ') }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="3">Batch Size :</v-col>
          <v-col cols="3">{{ trainingByTrainers.batchSize }}</v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="3">Registration End Date :</v-col>
          <v-col cols="3">{{formatDate(trainingByTrainers.registrationEndDate)}}</v-col>
        </v-row> -->
        <v-row>
          <v-col cols="3">Registered Staff :</v-col>
          <v-col cols="8">
            <v-row>
              <v-col
                cols="4"
                v-for="(enrolledUser, index) in previousSelectedStaff"
                :key="index"
              >
                <v-chip
                  close
                  @click:close="deregisterStaff(enrolledUser.enrollmentId)"
                  color="red"
                  text-color="white"
                  small
                  close-icon="mdi-delete"
                  >{{ enrolledUser.fullName }}</v-chip
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">Staff List :</v-col>
          <v-col cols="6">
            <multiselect
              placeholder="Select Teachers"
              class="overflowmultiselect2"
              label="fullName"
              track-by="id"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :preselect-first="false"
              :multiple="true"
              :options="teachersData"
              v-model="selectedStaff"
            ></multiselect>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <router-link slot="right" :to="{ name: 'AllTrainings' }">
              <v-btn class="px-2 ml-1 ma-1" min-width="0" small>Cancel</v-btn>
            </router-link>
          </v-col>
          <v-col cols="3">
            <v-btn
              class="px-2 ml-1 ma-1"
              @click="registerStaffTraining()"
              color="success"
              min-width="0"
              small
              >Register Staff</v-btn
            >
          </v-col>
        </v-row>
      </div>
    </material-card>
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import _ from 'lodash'
export default {
  name: 'RegisterStaff',
  props: {
    trainingID: String
  },
  components: {
    MaterialCard,
    Multiselect
  },
  data () {
    return {
      trainingByTrainers: null,
      registeredClasses: [],
      franchiseeIDs: [],
      selectedStaff: [],
      previousSelectedStaff: [],
      teachersData: [],
      className: []
    }
  },
  created: async function () {
    await this.getTrainingDetails()
  },

  methods: {
    getTrainingDetails: async function () {
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/teacher-training/get-training/${this.trainingID}`
        )
        this.trainingByTrainers = data
        // Class Name Bindings Start
        let classNames = []
        this.trainingByTrainers.trainingByTrainerClassgroupMaps.map(
          (clsMap) => {
            clsMap.studentClassGroupsMaps.map((grp) => {
              classNames.push(grp?.classDetails?.name || '')
            })
          }
        )
        this.className = _.filter(classNames, (cls) => cls !== '')
        // Class Name Bindings End
        this.franchiseeIDs = [
          ...new Set(
            this.trainingByTrainers.trainingByTrainerFranchiseeMaps.map(
              (obj) => obj.franchiseeId
            )
          )
        ]
        this.getApprovedStaffList()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    getApprovedStaffList: async function () {
      try {
        const { data } = await http.post(
          `${constants.API_URL}/api/teacher-training/get-staff?franchiseeID=${this.franchiseeIDs}&&isTeachingStaff=true`
        )
        _.map(data, (d) => {
          d.user.fullName = `${d.user.firstName} ${d.user.lastName} (${d.franchisee.companyName})`
          d.user.franchiseeID = d.franchisee.id
          this.teachersData.push(d.user)
        })
        let alreadySelectedStaffIds = []
        _.map(this.trainingByTrainers.trainingByTrainersEnrollments, (d) => {
          let enrol = {}
          enrol.enrollmentId = d.id
          enrol.userId = d.user.id
          alreadySelectedStaffIds.push(enrol)
        })
        let alreadySelectedStaffDetails = []
        _.map(this.teachersData, (teacher) => {
          _.forEach(alreadySelectedStaffIds, function (user) {
            if (teacher.id === user.userId) {
              teacher.enrollmentId = user.enrollmentId
              alreadySelectedStaffDetails.push(teacher)
            }
          })
        })
        this.previousSelectedStaff = alreadySelectedStaffDetails
        console.log(
          'enroll trainigs: ',
          this.trainingByTrainers.trainingByTrainersEnrollments
        )
        console.log('previously: ', this.previousSelectedStaff)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    registerStaffTraining: async function () {
      try {
        let staffs = []
        this.selectedStaff.forEach((user) => {
          let obj = {}
          obj.id = user.id
          obj.franchiseeID = user.franchiseeID
          staffs.push(obj)
        })
        let formData = {}
        formData.trainingId = this.trainingByTrainers.id
        console.log('trainingID: ', this.trainingByTrainers.id)
        formData.staffIds = staffs
        console.log('formData: ', formData)
        const { data } = await http.post(
          `${constants.API_URL}/api/teacher-training/register-staff`,
          formData
        )
        this.$buefy.dialog.alert({
          message: data.message,
          type: 'is-success'
        })
        this.$router.push({ name: 'AllTrainings' })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    deregisterStaff: async function (enrollmentId) {
      try {
        console.log('enrollmentid', enrollmentId)
        let formData = {}
        formData.trainingId = this.trainingByTrainers.id
        formData.enrollmentId = enrollmentId
        const { data } = await http.post(
          `${constants.API_URL}/api/teacher-training/deregister-staff`,
          formData
        )
        this.$buefy.dialog.alert({
          message: data,
          type: 'is-success'
        })
        let dropIndex = _.findIndex(this.previousSelectedStaff, function (o) {
          return o.enrollmentId === enrollmentId
        })
        this.previousSelectedStaff.splice(dropIndex)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    getStaff: async function () {
      const { data } = await http.get(
        `${constants.API_URL}/api/teacher-training/get-training/${this.trainingID}`
      )
      this.trainingByTrainers = data
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
#abcd {
  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;
}
</style>
